import cookieConsent from './components/cookie-consent.js'

export default {
    cookieConsent,
}
